import styled from '@emotion/styled'
import {Spacing} from 'types/Theme'

import {isolateContentDirection} from '@vio/atlas/src/utils/truncate'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

export const MODAL_WIDTH = 522
export const BEST_DEAL_IMAGE_HEIGHT = 180

export const HeaderElement = styled.div`
  display: flex;
  margin: 0;
  color: ${cssTheme.colors.content.neutral.inverse};
  justify-content: space-between;
  align-items: center;
`

export const ExitPopupHeaderContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-align: center;
`

export const AlarmIconWrapper = styled.span`
  margin-right: ${cssTheme.layout.spacing.s300};
`

export const PopupOfferContainer = styled.div`
  width: 100%;
`

export const PopupOffersContainer = styled.div`
  width: 100%;
  padding: ${cssTheme.layout.spacing.s400} ${cssTheme.layout.spacing.s600};
`

export const ExitPopupContentWrapper = styled.div<{
  paddingTop?: Spacing
  paddingRight?: Spacing
  paddingLeft?: Spacing
  paddingBottom?: Spacing
}>`
  max-width: 100%;
  padding: ${cssTheme.layout.spacing.s600};

  padding-top: ${({paddingTop = 's500'}) =>
    cssTheme.layout.spacing[paddingTop]};

  padding-bottom: ${({paddingBottom = 's600'}) =>
    cssTheme.layout.spacing[paddingBottom]};

  padding-right: ${({paddingRight = 's600'}) =>
    cssTheme.layout.spacing[paddingRight]};

  padding-left: ${({paddingLeft = 's600'}) =>
    cssTheme.layout.spacing[paddingLeft]};

  ${linariaMq.desktopXs} {
    width: ${MODAL_WIDTH}px;
  }
`

export const StarRatingWrapper = styled.div`
  margin-bottom: ${cssTheme.layout.spacing.s200};
`

export const HotelName = styled.div`
  ${cssTheme.typography.titleL}
  margin-bottom: ${cssTheme.layout.spacing.s100};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  ${isolateContentDirection()}
`

export const ImageWrapper = styled.div`
  position: relative;
  height: ${BEST_DEAL_IMAGE_HEIGHT}px;
  margin: ${cssTheme.layout.spacing.s200} 0 ${cssTheme.layout.spacing.s400};
`
